import { Group } from '@visx/group';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ShapeLine(_ref) {
  let {
    fill,
    width,
    height,
    style
  } = _ref;
  const cleanHeight = typeof height === 'string' || typeof height === 'undefined' ? 0 : height;
  const lineThickness = typeof style?.strokeWidth === 'number' ? style?.strokeWidth : 2;
  return /*#__PURE__*/_jsx("svg", {
    width: width,
    height: height,
    children: /*#__PURE__*/_jsx(Group, {
      top: cleanHeight / 2 - lineThickness / 2,
      children: /*#__PURE__*/_jsx("line", {
        x1: 0,
        x2: width,
        y1: 0,
        y2: 0,
        stroke: fill,
        strokeWidth: lineThickness,
        style: style
      })
    })
  });
}